// extracted by mini-css-extract-plugin
export var borderRadius = "_6v-4";
export var large = "_6v-3";
export var logoContainer = "_6v-0";
export var nameLogo = "_6v-2";
export var small = "_6v-1";